const Categories = () => (
  <p>Under construction</p>
);

export default Categories;
